// extracted by mini-css-extract-plugin
module.exports = {"portal-notifications-wrapper":"notifications-tab_portal-notifications-wrapper__10wfw","portal-notifications-card":"notifications-tab_portal-notifications-card__otspT"};